import { SDKError } from "../http/errors";
import { CoinRejectionCode } from "./contract";

export class BridgeError extends SDKError {
    constructor(message: string, details?: any) {
        super(message, undefined, details);
        this.name = 'BridgeError';
        this.errorCode = 'BRIDGE_ERROR';
    }
}

export class BridgeTimeoutError extends SDKError {
    constructor(message: string, details?: any) {
        super(message, undefined, details);
        this.name = 'BridgeTimeoutError';
        this.errorCode = 'BRIDGE_TIMEOUT';
    }
}

export class BridgeOriginError extends SDKError {
    constructor(message: string, details?: any) {
        super(message, undefined, details);
        this.name = 'BridgeOriginError';
        this.errorCode = 'BRIDGE_ORIGIN';
    }
}

export class BridgeValidationError extends SDKError {
    constructor(message: string, details?: any) {
        super(message, undefined, details);
        this.name = 'BridgeValidationError';
        this.errorCode = 'BRIDGE_VALIDATION';
    }
}

export class CoinGrantRejectedError extends SDKError {
    public code: CoinRejectionCode;
    public retryable: boolean;

    constructor(message: string, code: CoinRejectionCode, retryable: boolean, details?: any) {
        super(message, undefined, details);
        this.name = 'CoinGrantRejectedError';
        this.errorCode = 'COIN_GRANT_REJECTED';
        this.code = code;
        this.retryable = retryable;
    }
}

export class TokenRefreshError extends SDKError {
    constructor(message: string, details?: any) {
        super(message, undefined, details);
        this.name = 'TokenRefreshError';
        this.errorCode = 'TOKEN_REFRESH_FAILED';
    }
}
